import React__default from 'react';
import SvgIcon from '../../node_modules/@mui/material/SvgIcon/SvgIcon.esm.js';

const GreenCircleIcon = (props) => (React__default.createElement(SvgIcon, Object.assign({ width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React__default.createElement("circle", { cx: "12.5", cy: "12", r: "8", fill: "#00BF7C" })));

export { GreenCircleIcon as default };
